/**
 * JSON helper
 * @param {object} context - JSON data structure
 * @param {function} replacer
 * @param {string}  space
 * @returns {string} Stringified version of given context
*/
function json(context, replacer = null, space = 0) {
  const handleFunctions = typeof replacer === 'function' ? replacer : null;
  const handleWhitespace = typeof space === 'number' ? space : 0;
  return JSON.stringify(context, handleFunctions, handleWhitespace);
}

export { json };
